import Cookie from '@/utils/cookie-utils';

/**
 * Application environment class.
 */
class AppEnvironment {
  constructor() {
    this.logoutOnTokenExpired = Cookie.getCookie('logoutOnTokenExpired') === 'true';
  }

  /**
   * PAUS site perform logout flag. The value is gathered from logoutOnTokenExpired cookie. Initial idea was to get value from config.json file.
   * Because we do not have separate deployment for PAUS oliq site, the easiest solution is to configure PAUS NGINX server by setting logoutOnTokenExpired cookie.
   */
  logoutOnTokenExpired: boolean;
}

export const appEnvironment = new AppEnvironment();
